import { IComponentController } from 'angular';
import { IMonoOccurrence, IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaireItemSautDeLigneClass } from '../../../../../core/services/formulaire/formulaire-item-saut-de-ligne.service';
import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IMenuItemActionClass } from '../../../../../core/services/menu/menu-item-action.service';
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IMenuItemEcranClass } from '../../../../../core/services/menu/menu-item-ecran.service';
import { IStateService } from 'angular-ui-router';

interface IPageAl2007 extends IComponentController {
    valeursEcran: any;
    monoOccurrence: IMonoOccurrence;
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    adaMultiOccurrenceOptions: IMultiOccurrenceOptions;
    adaMultiOccurrence: IMultiOccurrence;
}

interface IAl2007Params {
    id: string;
    dlpcleint: string;
    menuId: string;
}


/* @ngInject */
export default function Al2007Controller(
    ecranDetails: IEcranDetailsResourcesEntite,
    Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    FormulaireItemSautDeLigne: IFormulaireItemSautDeLigneClass,
    Menu: IMenuClass,
    MenuItemAction: IMenuItemActionClass,
    MenuItemEcran: IMenuItemEcranClass,
    al2011Route: IRoute,
    as0008Route: IRoute,
    $state: IStateService,
    $stateParams: IAl2007Params
) {
    const vm: IPageAl2007 = this;

    vm.valeursEcran = ecranDetails.valeurs;

    vm.monoOccurrenceOptions = {
        fonctions: {
            boutonDupliquer: false
        },
        formulaire: new Formulaire('LBL_BLC_DLH', [
            new FormulaireItem('dlhdatvig', { largeur: 25 }),
            new FormulaireItem('dlhpctrep', { largeur: 25 }),
            new FormulaireItem('dlhseqmod', { largeur: 25, default: vm.valeursEcran.dalseqmodcou }),
            new FormulaireItem('dlhflgact', { largeur: 10, default: 1, alignRight: true }),
            new FormulaireItem('t_dlhflgact', { default: (data: any) => data.dlhflgact }),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('dlhcom', { largeur: 50, enableCount: true }),
            new FormulaireItem('dlhtauhor', { largeur: 25 })
        ])
    };

    vm.adaMultiOccurrenceOptions = {
        fonctions: {
            importation: false,
            boutonDupliquer: false
        },
        actionsNouveaux: new Menu([
            new MenuItemAction('BTN_GEN_AUT', 'BTNGENAUT', () => ({}), {
                icon: '',
                iconButton: false,
                hidden: () => vm.monoOccurrence.data.dlhseqmod !== vm.valeursEcran.dalseqmodcou,
                successAction: () => {
                    const menuItemEcran = new MenuItemEcran('', al2011Route.NAME, () => ({ id: vm.monoOccurrence.data.$id }), {
                        onClose: () => {
                            vm.adaMultiOccurrence.fetchDataList();
                        }
                    });

                    return menuItemEcran.action(null, {});
                }
            }),
            new MenuItemAction('BTN_GEN_MAN', 'BOUGENMAN', () => ({}), {
                icon: '',
                iconButton: false,
                formulaireConfirmationAction: {
                    lblTitre: 'ADD_MANUEL',
                    formulaire: new Formulaire([
                        new FormulaireItem('aftcleint', {
                            largeur: 50,
                            resourceParams: () => {
                                return {
                                    dlhcleint: vm.monoOccurrence.data.$id
                                };
                            }
                        }),
                        new FormulaireItem('asgcleint', {
                            largeur: 50,
                            resourceParams: (data: any) => {
                                return {
                                    dlhcleint: vm.monoOccurrence.data.$id,
                                    aftcleint: data.aftcleint
                                };
                            }
                        }),
                        new FormulaireItem('ahtcleint', {
                            largeur: 50,
                            resourceParams: (data: any) => {
                                return {
                                    dlhcleint: vm.monoOccurrence.data.$id,
                                    aftcleint: data.aftcleint,
                                    asgcleint: data.asgcleint
                                };
                            }
                        }),
                        new FormulaireItem('acycleint', {
                            largeur: 50,
                            resourceParams: (data: any) => {
                                return {
                                    dlhcleint: vm.monoOccurrence.data.$id,
                                    ahtcleint: data.ahtcleint,
                                    asgcleint: data.asgcleint
                                };
                            }
                        }),
                        new FormulaireItem('aeqcleint', { largeur: 50 })
                    ])
                },
                successAction: () => {
                    vm.adaMultiOccurrence.fetchDataList();
                },
                hidden: () => vm.valeursEcran.flgeditada || vm.monoOccurrence.data.dlhseqmod !== vm.valeursEcran.dalseqmodcou
            })
        ]),        
        navigatePage: as0008Route.NAME,
        navigateParams: (data: any) => ({
            id: data.ahtcleint,
            asgcleint: data.asgcleint,
            flgdal: 1
        }),
        colonnesFixesGauche: [
            { nom: 'aftcod', largeur: 104 },
            { nom: 'aftdscfmt', largeur: 280 }
        ],
        colonnesVisibles: [
            { nom: 'asgcod', largeur: 100 },
            { nom: 'asgdsc', largeur: 280 },
            { nom: 'ahtcod', largeur: 111 },
            { nom: 'ahtdsc', largeur: 280 },
            { nom: 'tcycod', largeur: 100 },
            { nom: 'acydsc', largeur: 280 },
            { nom: 'aeqcod', largeur: 100 },
            { nom: 'aeqnom', largeur: 280 },
            { nom: 'dursem', largeur: 105 },
            { nom: 'qtetra', largeur: 90 },
            { nom: 'qteabs', largeur: 90 },
            { nom: 'qtetot', largeur: 68 },
            { nom: 'prcprs', largeur: 79 }
        ],
        colonnesFixesDroite: [
            { nom: 'flgahtman', 
                largeur: 100,
                menu: [
                    new MenuItemAction('', 'BOUREM', () => ({ dlpcleint: vm.monoOccurrence.data.dlpcleint }), {
                        icon: 'edit',
                        iconButton: false,
                        saveFirst: true,
                        hidden: (data: any) => !data.ahtcleint || vm.valeursEcran.flgeditada || vm.monoOccurrence.data.dlhseqmod !== vm.valeursEcran.dalseqmodcou,
                        successAction: (retour: any) => {
                            $state.go(as0008Route.NAME, {
                                id: retour.t_ahtcleint,
                                asgcleint: retour.asgcleint,
                                flgman: 1,
                                flgdal: 1,
                                menuId: $stateParams.menuId
                            });
                        }
                    })
                ] }
        ],
        colonnesCachees: ['ahtcleint', 'asgcleint'],
        formulaire: new Formulaire([
            new FormulaireItem('aftcleint', {
                largeur: 30,
                resourceParams: () => {
                    return {
                        dlhcleint: vm.monoOccurrence.data.$id
                    };
                }
            }),
            new FormulaireItem('asgcleint', {
                largeur: 30,
                resourceParams: (data: any) => {
                    return {
                        dlhcleint: vm.monoOccurrence.data.$id,
                        aftcleint: data.aftcleint
                    };
                }
            }),
            new FormulaireItem('ahtcleint', {
                largeur: 30,
                resourceParams: (data: any) => {
                    return {
                        dlhcleint: vm.monoOccurrence.data.$id,
                        aftcleint: data.aftcleint,
                        asgcleint: data.asgcleint
                    };
                }
            }),
            new FormulaireItem('acycleint', {
                largeur: 30,
                resourceParams: (data: any) => {
                    return {
                        dlhcleint: vm.monoOccurrence.data.$id,
                        ahtcleint: data.ahtcleint,
                        asgcleint: data.asgcleint
                    };
                }
            }),
            new FormulaireItem('aeqcleint', { largeur: 30 })
        ])    
    };

}
